import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Box = styled.div`
  padding: 16px;
  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
`;

const Title = styled.div`
  padding-bottom: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #F9F9F9;
  text-align: center;
`;

const Text = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;
  text-align: left;
`;

const Divider = styled.div`
  width: 36px;
  height: 1px;
  background: #D28A28;
  margin: 18px auto;
`;

const TermsConditions = ({ title, rule }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
      <Divider />
      <Text dangerouslySetInnerHTML={{ __html: rule }} />
    </Box>
  );
};

export default TermsConditions;
